import logoMyBT from "@assets/logo-mybt-light.svg";
import Button from "@components/AccessibleComponents/Button";
import KeywordLimitModalVersion1RegContent from "@components/KeywordFilter/components/KeywordLimitModal/components/KeywordLimitModalVersion1RegContent";
import KeywordLimitModalVersion1SubContent from "@components/KeywordFilter/components/KeywordLimitModal/components/KeywordLimitModalVersion1SubContent";
import { KeywordLimitModalProps } from "@components/KeywordFilter/utils/types";
import Modal from "@components/Modal/Modal";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useWindowSize } from "@hooks/useWindowSize";
import useOKTAUserStore, { OKTAUserTypeEnum } from "@store/useOKTAUserStore";

/**
 * KeywordLimitModalVersion1 component
 */
export default function KeywordLimitModalVersion1({
  onClose,
  isModalOpen,
}: KeywordLimitModalProps): React.ReactElement {
  const closeModal = () => {
    onClose();
  };

  const OKTAUserInfo = useOKTAUserStore((state) => state.userInfo);
  const userType = OKTAUserInfo?.usertype;

  const { isScreenMD } = useWindowSize();

  return (
    <Modal
      isModalOpen={isModalOpen}
      setIsModalOpen={closeModal}
      dialogPanelClassNames="absolute left-1/2 right-1/2 -translate-x-1/2 -translate-y-1/2 md:w-[500px] w-full rounded-md bg-white ring-1 ring-gray-400 "
    >
      <div
        className="relative"
        data-testid="keyword-limit-modal-version-1-component"
      >
        <div className="flex items-center justify-between rounded-t-md p-1">
          <div className="text-neutral-800 dark:text-neutral-200 mx-auto text-xl font-medium lg:w-1/3"></div>
          <Button
            type="button"
            className="invisible box-content rounded-none border-none hover:no-underline hover:opacity-75 focus:opacity-100 focus:shadow-none focus:outline-none md:visible"
            onPress={closeModal}
          >
            <div className="fa-stack relative">
              <FontAwesomeIcon icon={faXmark} className="fa-stack-2x" />
            </div>
          </Button>
        </div>

        <div className="px-3 pb-3">
          <div className="item-center mx-auto flex place-content-center content-center">
            <img
              alt="logo-mybt-light.svg"
              src={logoMyBT}
              width={106}
              height={40}
            />
          </div>
        </div>

        {userType === OKTAUserTypeEnum.REGISTERED ? (
          <KeywordLimitModalVersion1RegContent />
        ) : (
          <KeywordLimitModalVersion1SubContent onClose={closeModal} />
        )}

        {!isScreenMD ? (
          <div className="container cursor-pointer md:hidden">
            <Button
              type="button"
              className="text-md w-full px-6 pb-2 pt-2.5 font-normal uppercase text-black focus:outline-none"
              onPress={closeModal}
            >
              MAYBE LATER
            </Button>
          </div>
        ) : null}
      </div>
    </Modal>
  );
}
